import { Navigate, Route, Routes } from 'react-router-dom';
import { useState } from 'react';
import RefrshHandler from './RefrshHandler';
import AuthForm from './components/AuthForm';
import Profile from './pages/Profile';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const PrivateRoute = ({ element }) => isAuthenticated ? element : <Navigate to="/login" />;
  const PublicRoute = ({ element }) => !isAuthenticated ? element : <Navigate to="/profile" />;
  return (
    <div>
      <ToastContainer />
      <RefrshHandler setIsAuthenticated={setIsAuthenticated} />
      <Routes>
        <Route path="/" element={<Navigate to="/signup" />} />
        <Route path="/signup" element={<PublicRoute element={<AuthForm setIsAuthenticated={setIsAuthenticated} />} />} />
        <Route path="/login" element={<PublicRoute element={<AuthForm isLogin={true} setIsAuthenticated={setIsAuthenticated} />} />} />
        <Route path="/profile" element={<PrivateRoute element={<Profile setIsAuthenticated={setIsAuthenticated} />} />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
}
export default App;
